import React from "react";
import { Container } from "semantic-ui-react";
import ChatRoomList from "../../containers/ChatRoomList";

const ChatRoomListPage = () => {
  return (
    <Container fluid>
      <ChatRoomList/>
    </Container>
  );
};
export default ChatRoomListPage;
